<div [ngSwitch]="normalizedSiteName" class="switch-contents">
  <div *ngSwitchCase="'stony creek'" class="switch-contents">
    <!-- <legacy-app-widget-water-monitoring-conductivity class="hide-check"></legacy-app-widget-water-monitoring-conductivity>  -->
    <app-rongo-mauri class="hide-check"></app-rongo-mauri>

    <app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaterLevels"></app-basic-cartesian-chart>
    <app-basic-cartesian-chart
      class="hide-check"
      [config]="ChartConfig.WhakaaweWaipaRiverNgaruawahia"
    ></app-basic-cartesian-chart>
    <app-basic-cartesian-chart
      class="hide-check"
      [config]="ChartConfig.WaiWaipaRiverNgaruawahia"
    ></app-basic-cartesian-chart>
  </div>

  <div *ngSwitchCase="'ngaruawahia'" class="switch-contents">
    <app-basic-cartesian-chart
      class="hide-check"
      [config]="ChartConfig.WhakaaweWaipaRiverNgaruawahia"
    ></app-basic-cartesian-chart>
    <app-basic-cartesian-chart
      class="hide-check"
      [config]="ChartConfig.WaiCablewayNgaruawahia"
    ></app-basic-cartesian-chart>
  </div>

  <div *ngSwitchDefault class="switch-contents">
    <H2>No layout configured for this site yet.</H2>
  </div>
</div>
